// extracted by mini-css-extract-plugin
module.exports = {"container":"oC-z","links":"pC-z"};